module.exports = __webpack_public_path__ + "img/NE.a745b6b3.svg";